
  // Event delegation to handle multiple image blocks, even if loaded dynamically
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.image-description-toggle');
    if (!btn) return;

    const captionId = btn.getAttribute('aria-controls');
    const caption = document.getElementById(captionId);
    if (!caption) return;

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    
    // Show/hide figcaption
    caption.hidden = expanded ? true : false;

    // Toggle button text
    btn.textContent = expanded ? 'View image description' : 'Hide image description';
  });
